import { css } from 'styled-components/macro';

export const highlightedInlineText = css`
  strong#orderId {
    display: inline-block;
    background: #eeb84f;
    color: white;
    padding: 2px 4px;
    border-radius: 3px;
    margin: 0 2px;
    position: relative;
    line-height: 1;
  }
`;
